import { render, staticRenderFns } from "./DocumentationHome.vue?vue&type=template&id=feafc54c"
import script from "./DocumentationHome.vue?vue&type=script&lang=js"
export * from "./DocumentationHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports